var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { GET_GLOBAL_SETTINGS, GetGlobalSettingsFailureAction, GetGlobalSettingsSuccessAction, UPDATE_GLOBAL_SETTINGS, UpdateGlobalSettingsFailureAction, UpdateGlobalSettingsSuccessAction } from './global-settings.actions';
import { GlobalSettingsService } from './global-settings.service';
var GlobalSettingsEffects = /** @class */ (function () {
    function GlobalSettingsEffects(actions$, globalSettingsService) {
        var _this = this;
        this.actions$ = actions$;
        this.globalSettingsService = globalSettingsService;
        this.getGlobalSettings$ = this.actions$.pipe(ofType(GET_GLOBAL_SETTINGS), switchMap(function () {
            return _this.globalSettingsService
                .getGlobalSettings()
                .pipe(map(function (response) { return new GetGlobalSettingsSuccessAction(response); }), catchError(function (error) { return of(new GetGlobalSettingsFailureAction(error)); }));
        }));
        this.updateGlobalSettings$ = this.actions$.pipe(ofType(UPDATE_GLOBAL_SETTINGS), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.globalSettingsService
                .updateGlobalSettings(payload)
                .pipe(map(function () { return new UpdateGlobalSettingsSuccessAction(payload); }), catchError(function (error) { return of(new UpdateGlobalSettingsFailureAction(error)); }));
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], GlobalSettingsEffects.prototype, "getGlobalSettings$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], GlobalSettingsEffects.prototype, "updateGlobalSettings$", void 0);
    return GlobalSettingsEffects;
}());
export { GlobalSettingsEffects };
